import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_ASSIGNMENT_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class Assignment extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-penugasan');
  }

  render() {
    const { handleGetAssignment } = this.props;
    return (
      <div className="assignment">
        <Button
          title="Tambah Surat Penugasan"
          onClick={this.onClickAdd}
        />
        <div className="assignment__content">
          <ContentTable
            onSearchContent={handleGetAssignment}
            tableFields={PERSONAL_ASSIGNMENT_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
Assignment.propTypes = {
  handleGetAssignment: PropTypes.func,
  history: PropTypes.object.isRequired,
};
Assignment.defaultProps = {
  handleGetAssignment: noop,
};
